import { cn, TextLayout } from '@lib-atria/ui-toolkit';
import { useMediaQuery } from 'react-responsive';
import { PendingAppointment } from '@/@types/pendingAppointment';
import { useCallback } from 'react';

type Props = {
  className?: string;
  pendingAppointments: PendingAppointment[];
};

export function AppointmentsCardPending({ className, pendingAppointments }: Props) {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const getQuarter = useCallback((date?: string) => {
    if (!date) return '';

    const appointmentDate = new Date(date);
    const month = appointmentDate.getMonth();
    const year = appointmentDate.getFullYear();

    const quarter = Math.floor(month / 3) + 1;

    return `Q${quarter} ${year}`;
  }, []);

  return (
    <div
      className={cn(
        'flex flex-col items-start justify-start gap-5 rounded-xl bg-white px-5 py-8 lg:px-9 lg:py-8',
        className
      )}
    >
      <div className='h-[0.5px] w-full bg-neue-kelp-400'></div>
      <div className='flex flex-col gap-[50px] lg:flex-row lg:gap-0 w-full'>
        <h2
          className={cn(
            isMobile ? TextLayout.h2.scto : TextLayout.callout1,
            'text-neue-kelp-400 lg:w-[27%] w-full mr-5'
          )}
        >
          To be scheduled
        </h2>

        <div className='flex lg:w-[73%] w-full flex-col justify-start gap-[40px] lg:gap-[75px]'>
          <h3 className={cn(TextLayout.h4.ivar, 'text-neue-kelp-400', 'leading-7')}>
            Your care team will reach out to schedule the following appointments. This list
            represents recommended appointments and may be adjusted based on your ongoing care
            needs.
          </h3>
          <div className='flex flex-col gap-10 items-start justify-start self-stretch'>
            {pendingAppointments.map((appointment, index) => (
              <div
                key={`appointment-${appointment.id}-${index}`}
                className='flex flex-col items-start gap-4 justify-start self-stretch border-t border-neue-kelp-400 py-4'
              >
                <div>
                  <div className={cn(TextLayout.callout3, 'text-neue-kelp-400')}>
                    {appointment.title}
                  </div>
                  {appointment.start && (
                    <div
                      className={cn(
                        TextLayout.callout3,
                        'text-gray-500',
                        'lg:text-gray-500',
                        'mt-0'
                      )}
                    >
                      {getQuarter(appointment.start)}
                    </div>
                  )}
                </div>

                <div className={cn(TextLayout.callout3, 'text-gray-500')}>
                  {appointment.memberNotes}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
